<div class="wrapper">
  <button class="primary square" (click)="minus()" [disabled]="isMinusDisabled">
    <ion-icon name="remove-outline"></ion-icon>
  </button>
  <input type="number"
         inputmode="numeric"
         [(ngModel)]="value"
         (input)="onChange()"
         (keydown)="onKeyDown($event)"
         [ngClass]="{error: isValid!=='true'}"
         [disabled]="disabled"
         onfocus="this.value = this.value == '0' ? '': this.value"
         (blur)=onBlur()
         (focusin)="onNoteFocus()"
  />
  <button class="primary square" (click)="plus()" [disabled]="disabled">
    <ion-icon name="add-outline"></ion-icon>
  </button>
</div>
